import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {ReactNode, useEffect} from 'react';

interface RenderIfBatteryDataKrProps {
  vin: string;
  onNoData?: () => void;
  children: ReactNode;
}

function RenderIfBatteryDataKr({vin, onNoData = () => {}, children}: RenderIfBatteryDataKrProps) {
  const {data: batteryData} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.battery.getBatteryStatus3), vin],
    queryFn: () => diApi.battery.getBatteryStatus3({vin}),
  });
  useEffect(() => {
    if (!batteryData?.data) {
      onNoData();
    }
  }, []);

  if (!batteryData?.data) {
    return null;
  }
  return <>{children}</>;
}

export default RenderIfBatteryDataKr;
